import React from 'react';
import { Link } from 'react-router-dom';
import { DISCLOSURES } from '../data/legal';
import AnchorLink from './AnchorLink';

const COLUMNS = [
  {
    head: 'Fund',
    links: [
      { label: 'Dashboard', to: '/dashboard' },
      { label: 'Growth', anchor: 'growth' },
      { label: 'Acceleration', anchor: 'acceleration' },
      { label: 'Team', href: 'https://www.draperdragon.com/#team' },
    ],
  },
  {
    head: 'Company',
    links: [
      { label: 'Draper Dragon', href: 'https://draperdragon.com' },
      { label: 'Draper University', href: 'https://draperuniversity.com' },
      { label: 'Cometa Labs', href: 'https://www.cometalabs.com/' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    head: 'Follow us',
    links: [
      { label: 'Orion Fund on X', href: 'https://x.com/OrionFund' },
      { label: 'Draper Dragon on X', href: 'https://x.com/DraperDragon' },
      { label: 'Cometa Labs on X', href: 'https://x.com/Cometa_Labs' },
      { label: 'LinkedIn', href: 'https://www.linkedin.com/company/draper-dragon/' },
    ],
  },
  {
    head: 'Legal',
    links: [
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Feedback', to: '/feedback' },
    ],
  },
];

const FooterLink = ({ l }) =>
  l.anchor ? (
    <AnchorLink id={l.anchor} className="of-footer-link">
      {l.label}
    </AnchorLink>
  ) : l.href ? (
    <a href={l.href} target="_blank" rel="noopener noreferrer" className="of-footer-link">
      {l.label}
    </a>
  ) : (
    <Link to={l.to} className="of-footer-link">
      {l.label}
    </Link>
  );

const Footer = () => {
  return (
    <footer className="apple-footer of-footer of-rails relative z-10">
      <div className="of-frame pt-14 md:pt-20">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-4 space-y-4">
            <img src="/orion-logo.svg" alt="Orion Fund" loading="lazy" decoding="async" width="183" height="40" className="h-10 w-auto" />
            <p className="text-sm leading-relaxed max-w-xs text-[color:var(--of-muted)]">
              Cardano's first professionally managed Ecosystem Fund, led by Draper Dragon.
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.head} className="md:col-span-2 space-y-4">
              <h4 className="of-footer-head">{col.head}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <FooterLink l={l} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Disclosures */}
        <div className="of-footer-disclosures mt-14 md:mt-20">
          <div className="flex items-center justify-between gap-4 mb-6">
            <h4 className="of-footer-head">Important disclosures</h4>
            <Link to="/terms" className="of-mono text-[11px] uppercase tracking-[0.08em] text-[color:var(--of-muted)] hover:text-white">
              Full terms →
            </Link>
          </div>
          <div className="space-y-5">
            {DISCLOSURES.map((d) => (
              <div key={d.title}>
                <div className="text-[13px] text-[color:var(--of-ink)]">{d.title}</div>
                {d.body.map((p) => (
                  <p key={p.slice(0, 32)} className="mt-1.5 text-[12px] leading-relaxed text-[color:var(--of-muted)]">
                    {p}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 py-6 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="of-mono text-xs text-[color:var(--of-muted)]">© {new Date().getFullYear()} Orion Fund · Draper Dragon. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/terms" className="of-mono text-xs text-[color:var(--of-muted)] hover:text-white">Terms</Link>
            <Link to="/privacy" className="of-mono text-xs text-[color:var(--of-muted)] hover:text-white">Privacy</Link>
          </div>
        </div>
      </div>
      <div className="of-footer-wordmark" aria-hidden="true" data-no-translate>
        <img src="/orion-wordmark.svg" alt="" loading="lazy" decoding="async" />
      </div>
    </footer>
  );
};

export default Footer;
